import dayjs from "dayjs"
import { getByIdOffline } from "./Get_one"
import { buildFullName } from "./queue"
import { readAllData, STORES } from "utility"

export async function getLettresOrientationOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.LETTRES_ORIENTATION)

  data = await Promise.all(
    data.map(async (l) => {
      let patient = l.patient

      if (!patient || typeof patient !== "object") {
        patient = await getByIdOffline(STORES.PATIENTS, l.patientId)
      }

      return {
        ...l,
        patient,
        fullName: l.fullName || buildFullName(patient),
      }
    }),
  )

  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((l) => l.fullName?.toLowerCase().includes(search))
  }

  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }

  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
